import { useUpdateTag, useTrackWithUser } from '@ion/api';

export default function useEditTag({ tag, onClose }) {
  const [trackTagUpdated] = useTrackWithUser('pipeline_tag_updated');
  const [updateTag] = useUpdateTag({
    onCompleted: () => {
      trackTagUpdated();
      onClose();
    },
  });

  const onSubmit = ({ label }) => {
    return updateTag({ id: tag.id, label });
  };

  return { onSubmit };
}
